<template>
  <div class="select-payment">
    <RadioPanel
      v-if="regular === 'no'"
      inputValue="paypal"
      v-model="selectedPayment"
    >
      <span class="select-payment__item">
        <span class="select-payment__item-label">PayPal</span>
        <span class="select-payment__item-icon">
          <img src="@/assets/images/paypal.svg" alt="PayPal" />
        </span>
      </span>
    </RadioPanel>
    <!--    <RadioPanel inputValue="sofortueberweisung" v-model="selectedPayment">-->
    <!--      <span class="select-payment__item">-->
    <!--        <span class="select-payment__item-label">Sofortüberweisung</span>-->
    <!--        <span class="select-payment__item-icon">-->
    <!--          <img src="@/assets/images/klarna.svg" alt="Klarna" />-->
    <!--        </span>-->
    <!--      </span>-->
    <!--    </RadioPanel>-->

    <RadioPanel inputValue="stripe_credit_card" v-model="selectedPayment">
      <span class="select-payment__item">
        <span class="select-payment__item-label">Kreditkarte</span>
        <span class="select-payment__item-icon">
          <img src="@/assets/images/master-card.svg" alt="MasterCard" />
          <img src="@/assets/images/visa.svg" alt="Visa" />
        </span>
      </span>
    </RadioPanel>
    <RadioPanel inputValue="wikando_direct_debit" v-model="selectedPayment">
      <span class="select-payment__item">
        <span class="select-payment__item-label">Lastschrift</span>
        <span class="select-payment__item-icon">
          <img src="@/assets/images/sepa.svg" alt="Lastschrift" />
        </span>
      </span>
    </RadioPanel>

    <RadioPanel
      v-if="['iOS', 'macOS'].includes(getMobileOperatingSystem) && isSafari()"
      inputValue="stripe_apple_pay"
      v-model="selectedPayment"
    >
      <span class="select-payment__item">
        <span class="select-payment__item-label">Apple Pay</span>
        <span class="select-payment__item-icon">
          <img src="@/assets/images/apple-pay.svg" alt="Apple Pay" />
        </span>
      </span>
    </RadioPanel>

    <RadioPanel
      v-if="getMobileOperatingSystem === 'Android'"
      inputValue="stripe_google_pay"
      v-model="selectedPayment"
    >
      <span class="select-payment__item">
        <span class="select-payment__item-label">Google Pay</span>
        <span class="select-payment__item-icon">
          <img src="@/assets/images/google-pay.svg" alt="Google Pay" />
        </span>
      </span>
    </RadioPanel>

    <div
      class="select-payment__card-fields"
      v-if="selectedPayment === 'wikando_direct_debit'"
    >
      <div class="select-payment__card-field">
        <InputText
          :label="globalSettings.labels_and_titles.account_owner"
          :isError="!formData.bank_account_owner.valid"
          :errorMessage="formData.bank_account_owner.error"
          v-model="formData.bank_account_owner.value"
          @change="validateField('bank_account_owner', 'formData')"
        />
        <InputText
          :label="globalSettings.labels_and_titles.bank_iban"
          :isError="!formData.bank_iban.valid"
          :errorMessage="formData.bank_iban.error"
          v-model="formData.bank_iban.value"
          @change="validateField('bank_iban', 'formData')"
        />
        <!--        <InputText-->
        <!--          :label="globalSettings.labels_and_titles.bank_bic"-->
        <!--          :isError="!formData.bank_bic.valid"-->
        <!--          :errorMessage="formData.bank_bic.error"-->
        <!--          v-model="formData.bank_bic.value"-->
        <!--          @change="validateField('bank_bic', 'formData')"-->
        <!--        />-->
      </div>
    </div>

    <div
      class="select-payment__stripe-fields"
      v-if="selectedPayment === 'stripe_credit_card'"
    >
      <div>
        <InputText
          :label="globalSettings.labels_and_titles.account_owner"
          :isError="!formData.bank_account_owner.valid"
          :errorMessage="formData.bank_account_owner.error"
          v-model="formData.bank_account_owner.value"
          @change="validateField('bank_account_owner', 'formData')"
        />
      </div>
      <div
        class="select-payment__stripe-group select-payment__stripe-group-card"
      >
        <div class="select-payment__stripe-label">
          {{ globalSettings.labels_and_titles.card_number }}
        </div>
        <input
          :value="stripe.card.value"
          class="select-payment__stripe-input"
          v-imask="stripe.card.mask"
          autocomplete="off"
          placeholder="xxxx xxxx xxxx xxxx"
          @accept="onAcceptCardType"
          @change="validateField('card', 'stripe')"
        />
        <div class="card-icon" v-html="stripe.card.cardTypeIcon"></div>
        <span
          class="select-payment__stripe-error-message"
          v-if="!stripe.card.valid && stripe.card.error"
        >
          {{ stripe.card.error }}
        </span>
      </div>

      <div class="select-payment__stripe-group">
        <div class="select-payment__stripe-label">
          {{ globalSettings.labels_and_titles.cvv }}
        </div>
        <input
          :value="stripe.cvv.value"
          class="select-payment__stripe-input"
          v-imask="stripe.cvv.mask"
          autocomplete="off"
          placeholder="xxxx"
          @accept="onAcceptCvv"
          @change="validateField('cvv', 'stripe')"
        />
        <span
          class="select-payment__stripe-error-message"
          v-if="!stripe.cvv.valid && stripe.cvv.error"
        >
          {{ stripe.cvv.error }}
        </span>
      </div>
      <div class="select-payment__stripe-group">
        <div class="select-payment__stripe-label">
          {{ globalSettings.labels_and_titles.expiration }}
        </div>
        <input
          :value="stripe.expiration.value"
          class="select-payment__stripe-input"
          v-imask="stripe.expiration.mask"
          autocomplete="off"
          placeholder="MM/YY"
          @accept="onAcceptExpirationDate"
          @change="validateField('expiration', 'stripe')"
        />
        <span
          class="select-payment__stripe-error-message"
          v-if="!stripe.expiration.valid && stripe.expiration.error"
        >
          {{ stripe.expiration.error }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import RadioPanel from '../RadioPanel/RadioPanel';
import InputText from '../InputText/InputText';
import { IMaskDirective, IMask } from 'vue-imask';
import { getMobileOperatingSystem, isSafari } from '@/utils';

export default {
  name: 'SelectPayment',
  components: { InputText, RadioPanel },
  props: {
    isSubmit: {
      type: Boolean,
    },
  },
  directives: {
    imask: IMaskDirective,
  },
  data() {
    return {
      stripe: {
        card: {
          value: '',
          cardTypeIcon: '',
          mask: {
            mask: [
              {
                mask: '0000 0000 0000 0000',
                regex:
                  '^(5[1-5]\\d{0,2}|22[2-9]\\d{0,1}|2[3-7]\\d{0,2})\\d{0,12}',
                cardType: 'mastercard',
              },
              {
                mask: '0000 0000 0000 0000',
                regex: '^4\\d{0,15}',
                cardType: 'visa',
              },
              {
                mask: '0000 0000 0000 0000',
                regex: '^(?:5[0678]\\d{0,2}|6304|67\\d{0,2})\\d{0,12}',
                cardType: 'maestro',
              },
              {
                mask: '0000 0000 0000 0000',
                cardType: 'unknown',
              },
            ],

            dispatch(appended, dynamicMasked) {
              const number = (dynamicMasked.value + appended).replace(
                /\D/g,
                ''
              );

              for (let i = 0; i < dynamicMasked.compiledMasks.length; i++) {
                const re = new RegExp(dynamicMasked.compiledMasks[i].regex);
                if (number.match(re) != null) {
                  return dynamicMasked.compiledMasks[i];
                }
              }
            },
          },
          cardIcons: {
            visa: `
           <svg width="660" height="203" viewBox="0 0 660 203" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M233.001 199.763L266.361 4H319.719L286.335 199.763H233.001Z" fill="#0E4595"/>
            <path d="M479.11 8.222C468.54 4.256 451.975 0 431.288 0C378.563 0 341.425 26.551 341.108 64.604C340.811 92.733 367.622 108.425 387.862 117.789C408.632 127.386 415.614 133.505 415.514 142.072C415.381 155.195 398.928 161.188 383.59 161.188C362.235 161.188 350.889 158.221 333.365 150.914L326.488 147.802L319 191.625C331.463 197.091 354.508 201.824 378.438 202.07C434.528 202.07 470.94 175.822 471.354 135.186C471.553 112.916 457.338 95.97 426.553 81.998C407.903 72.942 396.481 66.899 396.602 57.729C396.602 49.592 406.27 40.891 427.161 40.891C444.608 40.62 457.249 44.425 467.097 48.391L471.878 50.65L479.11 8.222Z" fill="#0E4595"/>
            <path d="M616.418 3.99901H575.188C562.415 3.99901 552.856 7.485 547.247 20.233L468.003 199.635H524.034C524.034 199.635 533.194 175.514 535.266 170.217C541.389 170.217 595.821 170.301 603.602 170.301C605.198 177.155 610.094 199.635 610.094 199.635H659.606L616.418 3.99901ZM551.001 130.407C555.415 119.128 572.261 75.683 572.261 75.683C571.947 76.204 576.642 64.349 579.335 56.999L582.942 73.877C582.942 73.877 593.159 120.606 595.294 130.404H551.001V130.407V130.407Z" fill="#0E4595"/>
            <path d="M187.706 3.99901L135.467 137.495L129.902 110.366C120.176 79.092 89.877 45.209 56.004 28.246L103.771 199.45L160.226 199.386L244.23 4L187.706 3.99901Z" fill="#0E4595"/>
            <path d="M86.723 3.99901H0.682003L0 8.07201C66.939 24.276 111.232 63.435 129.618 110.487L110.909 20.527C107.68 8.13101 98.312 4.43101 86.723 3.99901Z" fill="#F2AE14"/>
           </svg>

          `,
            mastercard: `
           <svg width="483" height="374" viewBox="0 0 483 374" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M87.39 373.17V348.32C87.39 338.79 81.59 332.58 72.07 332.58C67.07 332.58 61.72 334.24 57.99 339.58C55.09 335.02 50.99 332.58 44.74 332.58C42.4162 332.48 40.1038 332.957 38.0097 333.969C35.9155 334.981 34.1049 336.497 32.74 338.38V333.38H24.87V373.14H32.74V350.39C32.74 343.39 36.88 340.04 42.68 340.04C48.48 340.04 51.79 343.77 51.79 350.39V373.17H59.66V350.39C59.66 343.39 63.8 340.04 69.6 340.04C75.4 340.04 78.71 343.77 78.71 350.39V373.17H87.39ZM216.61 333.82H202.11V321.82H194.26V333.82H185.98V340.82H194.26V359.5C194.26 368.61 197.57 374 207.51 374C211.276 373.922 214.966 372.926 218.26 371.1L215.77 364.1C213.536 365.497 210.944 366.216 208.31 366.17C204.17 366.17 202.1 363.68 202.1 359.54V340.5H216.6V333.87L216.61 333.82ZM290.33 332.58C288.186 332.532 286.067 333.042 284.179 334.058C282.292 335.075 280.7 336.564 279.56 338.38V333.38H271.69V373.14H279.56V350.81C279.56 344.18 282.87 340.04 288.26 340.04C290.079 340.114 291.884 340.392 293.64 340.87L296.13 333.41C294.231 332.931 292.287 332.653 290.33 332.58V332.58ZM178.92 336.72C174.78 333.82 168.98 332.58 162.77 332.58C152.83 332.58 146.62 337.14 146.62 345.01C146.62 351.64 151.18 355.36 159.87 356.61L164.01 357.02C168.57 357.85 171.47 359.51 171.47 361.58C171.47 364.48 168.16 366.58 161.94 366.58C157.191 366.678 152.539 365.224 148.69 362.44L144.55 368.65C150.35 372.79 157.39 373.65 161.55 373.65C173.15 373.65 179.36 368.27 179.36 360.81C179.36 353.81 174.36 350.46 165.69 349.21L161.55 348.8C157.82 348.39 154.55 347.14 154.55 344.66C154.55 341.76 157.86 339.66 162.42 339.66C167.42 339.66 172.36 341.73 174.85 342.97L178.92 336.72ZM299.03 353.29C299.03 365.29 306.9 374 319.74 374C325.54 374 329.68 372.76 333.82 369.44L329.68 363.23C326.749 365.604 323.102 366.918 319.33 366.96C312.33 366.96 306.9 361.58 306.9 353.71C306.9 345.84 312.26 340.5 319.33 340.5C323.102 340.542 326.749 341.856 329.68 344.23L333.82 338.02C329.68 334.71 325.54 333.46 319.74 333.46C307.31 332.63 299.03 341.33 299.03 353.34V353.29ZM243.53 332.58C231.93 332.58 224.06 340.86 224.06 353.29C224.06 365.72 232.34 374 244.35 374C250.193 374.123 255.898 372.223 260.5 368.62L256.36 362.82C253.032 365.399 248.969 366.849 244.76 366.96C239.38 366.96 233.58 363.65 232.76 356.61H262.17V353.3C262.17 340.87 254.71 332.59 243.53 332.59V332.58ZM243.12 340.04C248.92 340.04 253.06 343.77 253.47 349.98H231.94C233.18 344.18 236.94 340.04 243.12 340.04V340.04ZM135.85 353.29V333.41H127.98V338.41C125.08 334.68 120.98 332.61 115.14 332.61C103.96 332.61 95.67 341.31 95.67 353.32C95.67 365.33 103.95 374.03 115.14 374.03C120.94 374.03 125.08 371.96 127.98 368.23V373.23H135.85V353.29ZM103.96 353.29C103.96 345.83 108.52 340.04 116.39 340.04C123.85 340.04 128.39 345.84 128.39 353.29C128.39 361.16 123.39 366.54 116.39 366.54C108.52 366.95 103.96 360.74 103.96 353.29ZM410.04 332.58C407.896 332.532 405.777 333.042 403.889 334.058C402.002 335.075 400.41 336.564 399.27 338.38V333.38H391.4V373.14H399.26V350.81C399.26 344.18 402.57 340.04 407.96 340.04C409.779 340.114 411.584 340.392 413.34 340.87L415.83 333.41C413.931 332.931 411.987 332.653 410.03 332.58H410.04ZM379.39 353.29V333.41H371.52V338.41C368.62 334.68 364.52 332.61 358.68 332.61C347.5 332.61 339.21 341.31 339.21 353.32C339.21 365.33 347.49 374.03 358.68 374.03C364.48 374.03 368.62 371.96 371.52 368.23V373.23H379.39V353.29ZM347.5 353.29C347.5 345.83 352.06 340.04 359.93 340.04C367.39 340.04 371.93 345.84 371.93 353.29C371.93 361.16 366.93 366.54 359.93 366.54C352.06 366.95 347.5 360.74 347.5 353.29ZM459.33 353.29V317.67H451.46V338.38C448.56 334.65 444.46 332.58 438.62 332.58C427.44 332.58 419.15 341.28 419.15 353.29C419.15 365.3 427.43 374 438.62 374C444.42 374 448.56 371.93 451.46 368.2V373.2H459.33V353.29ZM427.44 353.29C427.44 345.83 432 340.04 439.87 340.04C447.33 340.04 451.87 345.84 451.87 353.29C451.87 361.16 446.87 366.54 439.87 366.54C431.99 366.96 427.43 360.75 427.43 353.29H427.44Z" fill="black"/>
            <path d="M313.53 31.89H169.81V266.31H313.53V31.89Z" fill="#FF5F00"/>
            <path d="M184.31 149.1C184.315 126.549 189.422 104.291 199.248 83.9926C209.074 63.6945 223.365 45.8824 241.05 31.89C219.056 14.5972 192.64 3.84168 164.821 0.853073C137.003 -2.13554 108.905 2.76332 83.7392 14.9896C58.5736 27.2159 37.3558 46.2764 22.5113 69.992C7.66675 93.7077 -0.205444 121.122 -0.205444 149.1C-0.205444 177.078 7.66675 204.492 22.5113 228.208C37.3558 251.924 58.5736 270.984 83.7392 283.21C108.905 295.437 137.003 300.336 164.821 297.347C192.64 294.358 219.056 283.603 241.05 266.31C223.365 252.318 209.074 234.505 199.248 214.207C189.422 193.909 184.315 171.651 184.31 149.1V149.1Z" fill="#EB001B"/>
            <path d="M482.52 149.1C482.54 177.058 474.691 204.457 459.871 228.164C445.051 251.871 423.858 270.928 398.716 283.156C373.573 295.384 345.497 300.289 317.698 297.31C289.899 294.331 263.5 283.588 241.52 266.31C259.21 252.321 273.503 234.51 283.33 214.211C293.157 193.912 298.262 171.652 298.262 149.1C298.262 126.548 293.157 104.288 283.33 83.989C273.503 63.6901 259.21 45.8788 241.52 31.89C263.5 14.6121 289.899 3.86925 317.698 0.890105C345.497 -2.08904 373.573 2.81583 398.716 15.0437C423.858 27.2716 445.051 46.3288 459.871 70.0357C474.691 93.7426 482.54 121.142 482.52 149.1V149.1Z" fill="#F79E1B"/>
           </svg>
          `,
            maestro: `
          <svg width="483" height="375" viewBox="0 0 483 375" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M145.9 373.27V348.5C145.9 339.15 139.9 332.86 130.35 332.78C125.35 332.7 120.09 334.27 116.45 339.78C113.72 335.4 109.45 332.78 103.38 332.78C101.106 332.666 98.8414 333.147 96.8104 334.177C94.7794 335.206 93.0523 336.748 91.8001 338.65V333.77H83.1901V373.32H91.8801V351.35C91.8801 344.48 95.6901 340.84 101.56 340.84C107.27 340.84 110.17 344.56 110.17 351.26V373.26H118.86V351.35C118.86 344.48 122.86 340.84 128.54 340.84C134.41 340.84 137.23 344.56 137.23 351.26V373.26L145.9 373.27ZM194.38 353.5V333.73H185.77V338.5C183.04 334.94 178.9 332.71 173.28 332.71C162.19 332.71 153.51 341.4 153.51 353.48C153.51 365.56 162.2 374.25 173.28 374.25C178.91 374.25 183.04 372.02 185.77 368.46V373.26H194.38V353.5ZM162.38 353.5C162.38 346.55 166.93 340.84 174.38 340.84C181.5 340.84 186.29 346.3 186.29 353.5C186.29 360.7 181.49 366.16 174.38 366.16C166.91 366.16 162.36 360.45 162.36 353.5H162.38ZM378.5 332.69C381.407 332.661 384.291 333.201 386.99 334.28C389.505 335.285 391.798 336.773 393.74 338.66C395.653 340.536 397.17 342.777 398.2 345.25C400.346 350.548 400.346 356.472 398.2 361.77C397.17 364.243 395.653 366.484 393.74 368.36C391.798 370.248 389.505 371.736 386.99 372.74C381.523 374.868 375.457 374.868 369.99 372.74C367.48 371.739 365.192 370.25 363.26 368.36C361.359 366.479 359.849 364.239 358.82 361.77C356.674 356.472 356.674 350.548 358.82 345.25C359.85 342.781 361.359 340.542 363.26 338.66C365.192 336.77 367.48 335.282 369.99 334.28C372.696 333.199 375.587 332.659 378.5 332.69ZM378.5 340.83C376.818 340.815 375.15 341.131 373.59 341.76C372.12 342.35 370.786 343.235 369.67 344.36C368.547 345.508 367.663 346.868 367.07 348.36C365.804 351.67 365.804 355.33 367.07 358.64C367.663 360.133 368.547 361.492 369.67 362.64C370.786 363.765 372.12 364.65 373.59 365.24C376.75 366.479 380.261 366.479 383.42 365.24C384.894 364.646 386.234 363.762 387.36 362.64C388.493 361.496 389.384 360.136 389.98 358.64C391.246 355.33 391.246 351.67 389.98 348.36C389.384 346.864 388.493 345.504 387.36 344.36C386.234 343.238 384.894 342.354 383.42 341.76C381.858 341.127 380.186 340.807 378.5 340.82V340.83ZM241.2 353.5C241.12 341.17 233.51 332.73 222.42 332.73C210.84 332.73 202.73 341.17 202.73 353.5C202.73 366.08 211.17 374.27 223 374.27C229 374.27 234.42 372.78 239.22 368.73L235 362.36C231.733 364.98 227.687 366.436 223.5 366.5C217.96 366.5 212.91 363.94 211.67 356.82H241.04C241.1 355.73 241.2 354.66 241.2 353.5ZM211.75 350.03C212.66 344.32 216.13 340.43 222.26 340.43C227.8 340.43 231.36 343.9 232.26 350.03H211.75ZM277.44 343.83C273.683 341.666 269.436 340.495 265.1 340.43C260.38 340.43 257.57 342.17 257.57 345.06C257.57 347.71 260.57 348.45 264.27 348.95L268.32 349.53C276.93 350.77 282.14 354.41 282.14 361.36C282.14 368.89 275.52 374.27 264.14 374.27C257.69 374.27 251.73 372.61 247.01 369.14L251.06 362.44C254.858 365.258 259.493 366.716 264.22 366.58C270.09 366.58 273.22 364.84 273.22 361.78C273.22 359.55 270.99 358.31 266.27 357.64L262.22 357.06C253.37 355.82 248.57 351.85 248.57 345.39C248.57 337.53 255.02 332.73 265.03 332.73C271.32 332.73 277.03 334.14 281.16 336.87L277.44 343.83ZM318.79 341.6H304.72V359.5C304.72 363.5 306.13 366.12 310.43 366.12C313.114 366.032 315.733 365.265 318.04 363.89L320.52 371.25C317.293 373.262 313.563 374.322 309.76 374.31C299.58 374.31 296.03 368.85 296.03 359.66V341.66H288.03V333.8H296.03V321.8H304.72V333.8H318.78L318.79 341.6ZM348.57 332.75C350.657 332.76 352.726 333.125 354.69 333.83L352.04 341.94C350.33 341.256 348.502 340.916 346.66 340.94C341.03 340.94 338.22 344.58 338.22 351.12V373.29H329.62V333.73H338.1V338.5C339.155 336.687 340.68 335.192 342.514 334.173C344.348 333.154 346.423 332.648 348.52 332.71L348.57 332.75Z" fill="black"/>
            <path d="M306.55 31.89H176.05V266.4H306.55V31.89Z" fill="#7673C0"/>
            <path d="M184.34 149.14C184.323 126.551 189.446 104.254 199.321 83.9386C209.197 63.6228 223.566 45.8205 241.34 31.88C219.339 14.5869 192.916 3.83268 165.092 0.846541C137.267 -2.1396 109.164 2.7628 83.9944 14.9934C58.8246 27.2241 37.6037 46.2894 22.757 70.0104C7.91038 93.7314 0.0371094 121.151 0.0371094 149.135C0.0371094 177.119 7.91038 204.539 22.757 228.26C37.6037 251.981 58.8246 271.046 83.9944 283.277C109.164 295.507 137.267 300.41 165.092 297.423C192.916 294.437 219.339 283.683 241.34 266.39C223.567 252.451 209.199 234.65 199.324 214.336C189.448 194.022 184.324 171.727 184.34 149.14V149.14Z" fill="#EB001B"/>
            <path d="M482.6 149.14C482.601 177.124 474.728 204.544 459.882 228.265C445.036 251.986 423.815 271.052 398.646 283.283C373.476 295.514 345.373 300.417 317.549 297.432C289.725 294.446 263.302 283.692 241.3 266.4C259.051 252.442 273.402 234.636 283.27 214.325C293.138 194.013 298.265 171.727 298.265 149.145C298.265 126.563 293.138 104.277 283.27 83.965C273.402 63.6535 259.051 45.8476 241.3 31.89C263.301 14.598 289.723 3.8446 317.546 0.858737C345.37 -2.12713 373.472 2.77503 398.641 15.005C423.81 27.2349 445.031 46.2991 459.878 70.0189C474.725 93.7386 482.599 121.157 482.6 149.14V149.14Z" fill="#00A1DF"/>
          </svg>
          `,
          },
          valid: true,
          validation: ['required'],
          error: '',
        },
        expiration: {
          value: '',
          mask: {
            mask: 'MM{/}YY',
            blocks: {
              YY: {
                mask: IMask.MaskedRange,
                from: 1,
                to: 99,
                maxLength: 2,
              },
              MM: {
                mask: IMask.MaskedRange,
                from: 1,
                to: 12,
                maxLength: 2,
              },
            },
          },
          valid: true,
          validation: ['required', 'MM/YY'],
          error: '',
        },
        cvv: {
          value: '',
          mask: {
            mask: '0000',
          },
          valid: true,
          validation: ['required'],
          error: '',
        },
      },
      formData: {
        bank_account_owner: {
          value: '',
          valid: true,
          validation: ['required'],
          hidden: false,
          error: '',
        },
        bank_iban: {
          value: '',
          valid: true,
          validation: ['required'],
          hidden: false,
          error: '',
        },
        // bank_bic: {
        //   value: '',
        //   valid: true,
        //   validation: ['required'],
        //   hidden: false,
        //   error: '',
        // },
      },
    };
  },
  watch: {
    selectedPayment(val) {
      if (['stripe_apple_pay', 'stripe_google_pay'].includes(val)) {
        document.querySelector('.form__button .button').click();
        // this.$store.commit('donationPayment/setGoogleApplePayData', {
        //   payment_status: 'awaiting',
        //   redirect_url: '',
        //   payment_intent: {
        //     client_secret:
        //       'pi_3QPhmNBtMygzAr4A2YT1rEYo_secret_W6Rxy35d5g3bCN3LdqAzR7T1p',
        //     amount: 200,
        //     currency: 'eur',
        //     description: 'FB-T-28050248',
        //     orga_name: 'Stiftung Frauenkirche Dresden',
        //     publishable_key: 'pk_live_a9FYPQU5rCYUFVAV5117uxNa',
        //     stripe_account: 'acct_1K57OSBtMygzAr4A',
        //   },
        // });
        // this.$store.dispatch('donationPayment/prepareAppleGooglePay');
      } else {
        this.$store.commit('donationPayment/setGoogleApplePayData', {});
      }
    },
    'formData.bank_account_owner.value'(val) {
      this.$store.commit('donationPayment/setBankAccountOwner', val);
      if (!this.inHouse) localStorage.setItem('bankAccountOwner', val);
    },
    'formData.bank_iban.value'(val) {
      this.$store.commit('donationPayment/setBankIban', val);
      if (!this.inHouse) localStorage.setItem('bankIban', val);
    },
    // 'formData.bank_bic.value'(val) {
    //   this.$store.commit('donationPayment/setBankBic', val);
    //   localStorage.setItem('bankBic', val);
    // },
    'stripe.card.value'(val) {
      this.$store.commit('donationPayment/setStripeCardNumber', val);
      if (!this.inHouse) localStorage.setItem('stripe/card', val);
    },
    'stripe.expiration.value'(val) {
      this.$store.commit('donationPayment/setStripeCardExpiry', val);
      if (!this.inHouse) localStorage.setItem('stripe/expiration', val);
    },
    isSubmit(val) {
      if (this.$store.getters['donationPayment/isSepa'] && val) {
        for (const field in this.formData) {
          this.validateField(field, 'formData');
        }
      } else if (this.$store.getters['donationPayment/isStripe'] && val) {
        for (const field in this.stripe) {
          this.validateField(field, 'stripe');
        }
      }
    },
  },
  computed: {
    inHouse() {
      return this.$store.state.global.inHouse;
    },
    getMobileOperatingSystem() {
      return getMobileOperatingSystem();
    },

    regular() {
      return this.$store.state.donationProductForm.formData.regular;
    },
    globalSettings() {
      return this.$store.state.global.settings;
    },
    donationId() {
      return this.$store.state.donationPayment.donationPostId;
    },
    amount() {
      return this.$store.state.donationPayment.amount;
    },
    postId() {
      return this.$store.state.donationPayment.postId;
    },
    postType() {
      return this.$store.state.donationPayment.postType;
    },
    selectedPayment: {
      get() {
        return this.$store.state.donationPayment.paymentMethod;
      },
      set(method) {
        this.$store.commit('donationPayment/setPaymentMethod', method);
      },
    },
  },
  mounted() {
    const bankAccountOwner = this.readStored('bankAccountOwner');
    const bankIban = this.readStored('bankIban');
    // const bankBic = localStorage.getItem('bankBic') || '';
    this.$store.commit('donationPayment/setBankAccountOwner', bankAccountOwner);
    this.$store.commit('donationPayment/setBankIban', bankIban);
    // this.$store.commit('donationPayment/setBankBic', bankBic);
    this.formData.bank_account_owner.value = bankAccountOwner;
    this.formData.bank_iban.value = bankIban;
    // this.formData.bank_bic.value = bankBic;

    const stripeCard = this.readStored('stripe/card');
    this.$store.commit('donationPayment/setStripeCardNumber', stripeCard);
    this.stripe.card.value = stripeCard;
    const stripeExpiration = this.readStored('stripe/expiration');
    this.$store.commit('donationPayment/setStripeCardExpiry', stripeExpiration);
    this.stripe.expiration.value = stripeExpiration;

    if (this.regular !== 'no') {
      this.$store.commit(
        'donationPayment/setPaymentMethod',
        'sofortueberweisung'
      );
    } else {
      this.$store.commit('donationPayment/setPaymentMethod', 'paypal');
    }
  },
  methods: {
    readStored(key) {
      return this.inHouse ? '' : localStorage.getItem(key) || '';
    },
    isSafari,
    validateField(field, formKey) {
      const fieldValidation = this[formKey][field].validation;
      if (Array.isArray(fieldValidation)) {
        if (fieldValidation.includes('required')) {
          this[formKey][field].valid = this[formKey][field].value !== '';
          if (!this[formKey][field].valid) {
            this[formKey][field].error =
              this.globalSettings['labels_and_titles']['form_errors'][
                'required'
              ];
          }
        }
        if (this[formKey][field].valid && fieldValidation.includes('MM/YY')) {
          this[formKey][field].valid =
            this[formKey][field].value &&
            this[formKey][field].value.length === 5;
          if (!this[formKey][field].valid) {
            this[formKey][field].error =
              this.globalSettings['labels_and_titles']['form_errors']['mmyy'];
          }
        }
      }
    },
    onAcceptCardType(e) {
      const maskRef = e.detail;

      if (maskRef.masked.currentMask) {
        const type = maskRef.masked.currentMask.cardType;
        this.stripe.card.cardTypeIcon =
          type in this.stripe.card.cardIcons
            ? this.stripe.card.cardIcons[type]
            : '';
      }

      this.stripe.card.value = maskRef.value;
      this.$store.commit(
        'donationPayment/setStripeCardNumber',
        this.stripe.card.value
      );
    },
    onAcceptCvv(e) {
      const maskRef = e.detail;
      this.stripe.cvv.value = maskRef.value;
      this.$store.commit(
        'donationPayment/setStripeCardCvv',
        this.stripe.cvv.value
      );
    },
    onAcceptExpirationDate(e) {
      const maskRef = e.detail;
      this.stripe.expiration.value = maskRef.value;
      this.$store.commit(
        'donationPayment/setStripeCardExpiry',
        this.stripe.expiration.value
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'styles';
</style>
